import { GetProfileResponse } from '@features/user/types/get-profile-response';
import { setGaUserProperties } from '@src/lib/google-analytics';
import { useEffect } from 'react';

/** Keep the member's GA user properties current as the profile changes. */
export function useGaUserProperties(profile: GetProfileResponse | undefined) {
  useEffect(() => {
    if (profile) {
      setGaUserProperties(profile);
    }
  }, [profile]);
}
